import { scrollSmootherInstance, gsap, ScrollTrigger } from './gsap';

class Footer {
  constructor($el) {
    this.$el = $el;
    this.$links = this.$el.find('[data-footer="link"]');

    this.init();
  }

  init = () => {
    // create a scroll trigger for the footer
    ScrollTrigger.create({
      id: 'footer',
      trigger: this.$el,
      markers: false,
      onEnter: () => {
        //  stagger the links
        gsap.fromTo(
          this.$links,
          {
            y: '100%',
          },
          {
            duration: 0.5,
            y: '0%',
            stagger: 0.2,
          }
        );
      },
    });
  }
}

export default new Footer($('[data-footer="el"]'));
